function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React from "react";
import { twMerge } from "@stereoagency/tailwind-config";
import { offset, shift } from "@floating-ui/react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown, DeDuveLogo, Search } from "../../visuals";
import { MenuToggle, NavigationItem } from "../../molecules";
import ReactConfig from "../../ReactConfig";
import { CallToAction } from "../../atoms";
import useNavbarContext from "./useNavbarContext";
import { fadeIn } from "../../motion/variants";
export default function NavBarHeader(param) {
    var homepageAction = param.homepageAction, searchAction = param.searchAction, action = param.action, menuOpen = param.menuOpen, menuItems = param.menuItems, languageOptions = param.languageOptions, className = param.className, onToggle = param.onToggle;
    var _languageOptions_options;
    var _useNavbarContext = _sliced_to_array(useNavbarContext(), 1), contentOverride = _useNavbarContext[0].contentOverride;
    var LinkComponent = ReactConfig.LinkComponent;
    var _languageOptions_options_map;
    return /*#__PURE__*/ React.createElement("div", {
        className: twMerge("py-5 px-6 container", className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-rows-1 items-center"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "col-start-1 row-start-1 hidden md:block"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center justify-center px-[11.75rem]"
    }, menuItems.map(function(item) {
        return /*#__PURE__*/ React.createElement("div", {
            key: "item-".concat(item.action.href),
            className: "mx-5"
        }, /*#__PURE__*/ React.createElement(NavigationItem, {
            active: item.active,
            action: item.action,
            submenu: item.submenu
        }));
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "col-start-1 row-start-1 flex items-center justify-between pointer-events-none"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(LinkComponent, _object_spread_props(_object_spread({}, homepageAction), {
        className: twMerge("pointer-events-auto", homepageAction.className)
    }), /*#__PURE__*/ React.createElement(DeDuveLogo, {
        className: twMerge("block w-[11.75rem] h-auto", menuOpen && '[&_[fill="#004E9C"]]:fill-white')
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "pointer-events-auto hidden grid-rows-1 grid-flow-col auto-cols-max gap-6 items-center md:grid"
    }, !!searchAction && /*#__PURE__*/ React.createElement(LinkComponent, searchAction, /*#__PURE__*/ React.createElement(Search, null)), !!action && /*#__PURE__*/ React.createElement(CallToAction, action), !!languageOptions && /*#__PURE__*/ React.createElement(NavigationItem, {
        icon: /*#__PURE__*/ React.createElement(ChevronDown, null),
        action: languageOptions === null || languageOptions === void 0 ? void 0 : languageOptions.active,
        middleware: [
            shift({}),
            offset({
                mainAxis: 24,
                crossAxis: -12
            })
        ],
        submenu: (_languageOptions_options_map = languageOptions === null || languageOptions === void 0 ? void 0 : (_languageOptions_options = languageOptions.options) === null || _languageOptions_options === void 0 ? void 0 : _languageOptions_options.map(function(opt) {
            return {
                label: opt.label,
                href: opt.href,
                locale: opt.locale,
                onClick: opt.onClick
            };
        })) !== null && _languageOptions_options_map !== void 0 ? _languageOptions_options_map : []
    })), /*#__PURE__*/ React.createElement("div", {
        className: "pointer-events-auto md:hidden"
    }, /*#__PURE__*/ React.createElement(MenuToggle, {
        open: menuOpen,
        onClick: onToggle
    }))), /*#__PURE__*/ React.createElement(AnimatePresence, null, !!contentOverride && /*#__PURE__*/ React.createElement(motion.div, {
        variants: fadeIn,
        initial: "hide",
        exit: "hide",
        animate: "show",
        className: "col-start-1 row-start-1 bg-bg-base h-full z-10"
    }, contentOverride))));
}

//# sourceMappingURL=NavBarHeader.js.map